import React from 'react';

import { countFormat, getSelectLabel, lang, userFullName } from 'src/helpers';
import moment from 'moment/moment';
import { Avatar } from 'src/components/basic';
import constants from 'src/constants';

export const DoctorProfileCard = React.memo(({ doctor }) => (
  <>
    <Avatar text={userFullName(doctor)} width={120} height={120} image={doctor.avatar} />
    <div className={'mc-flex-15-col'}>
      <div className={'mc-value-620'}>{'Dr. ' + userFullName(doctor)}</div>
      <div className={'mc-label-418'}>
        {getSelectLabel(constants.general.specialist, doctor.specialist)}
      </div>
    </div>
    <pre className={'mc-value-418'}>{doctor.address}</pre>
    <div className={'mc-flex'}>
      <div className={'mc-label-416 mc-grow'}>{lang.t('Total Treatments')}</div>
      <div className={'mc-value-616'}>{countFormat(doctor.treatmentCount)}</div>
    </div>
    <div className={'mc-flex'}>
      <div className={'mc-label-416 mc-grow'}>{lang.t('Experience')}</div>
      {doctor.training && (
        <div className={'mc-value-616'}>{doctor.training + ' ' + lang.t('years')}</div>
      )}
    </div>
    <div className={'mc-flex'}>
      <div className={'mc-label-416 mc-grow'}>{lang.t('Date Of Joining')}</div>
      <div className={'mc-value-616'}>
        {doctor.created && moment(doctor.created).format('DD MMM YYYY')}
      </div>
    </div>
  </>
));
